import requestWrapper from '../../requestWrapper';
import endpoints from './endpoints';
import type {DataResponseWrapper} from '@deezer/next/services/api/Starmania/requests/types';
import type {TrackPerformances, TrackTop} from './types';
import type {
	AnalyticFilters,
	AnalyticsFavorites,
	AnalyticsDemographics,
	AnalyticsMap,
	AnalyticsStreamingContext,
} from '../types';

const {get} = requestWrapper;

const requests = {
	getPerformances: (isrc: string, filters: AnalyticFilters) =>
		get<DataResponseWrapper<TrackPerformances>>(endpoints.performances(isrc), {
			params: filters,
		}),
	getTop: (isrc: string, filters: AnalyticFilters) =>
		get<DataResponseWrapper<TrackTop>>(endpoints.top(isrc), {
			params: filters,
		}),
	getFavorites: (isrc: string, filters: AnalyticFilters) =>
		get<DataResponseWrapper<AnalyticsFavorites>>(endpoints.favorites(isrc), {
			params: filters,
		}),
	getMap: (isrc: string, filters: AnalyticFilters) =>
		get<DataResponseWrapper<AnalyticsMap>>(endpoints.map(isrc), {
			params: filters,
		}),
	getDemographics: (isrc: string, filters: AnalyticFilters) =>
		get<DataResponseWrapper<AnalyticsDemographics>>(
			endpoints.demographics(isrc),
			{
				params: filters,
			},
		),
	getStreamingContext: (isrc: string, filters: AnalyticFilters) =>
		get<DataResponseWrapper<AnalyticsStreamingContext>>(
			endpoints.streamingContext(isrc),
			{
				params: filters,
			},
		),
};

export default requests;
